import { PregnancyAndBreastfeedingContentModel } from './pregnancyAndBreastfeedingContentModel';

export class PregnancyAndBreastfeedingModel {
  public pregnancyAndBreastfeedingContentId: number;
  public medicineId: number;
  public shortDescription: string;
  public description: string;
  public pregnancyAndBreastfeedingContent: Array<PregnancyAndBreastfeedingContentModel>
}